const CompanyRoutes = [];

export default CompanyRoutes;
